export const isAltairChart = (contents: string): boolean => {
  return contents.match(/(altair-viz-[\d\w]+)/g) != null;
};
